(() => {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-spaz-load-embed]');
    if (!button) return;

    const container = button.closest('[data-spaz-deferred-embed]');
    const src = container?.dataset.src;
    if (!container || !src || container.dataset.loaded === 'true') return;

    container.dataset.loaded = 'true';

    const iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.title = container.dataset.title || button.textContent.trim();
    iframe.loading = 'lazy';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allowFullscreen = true;

    if (container.dataset.allow) {
      iframe.setAttribute('allow', container.dataset.allow);
    }

    container.replaceChildren(iframe);
  });
})();
